import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-icon-badge-header',
  standalone: true,
  templateUrl: './icon-badge-header.component.html',
  styleUrls: ['./icon-badge-header.component.scss'],
  imports: [CommonModule, MatIconModule, TranslateModule],
})
export class IconBadgeHeaderComponent {
  /** Name of an icon registered with `MatIconRegistry`, e.g. `ph-regular-gavel`. */
  @Input() svgIcon?: string;
  @Input() titleKey!: string;
  /** Raw text title for content that is not a translation key (e.g. a published document title). */
  @Input() title?: string;
  @Input() subtitleBoldKey?: string | null;
  @Input() subtitleLightKey?: string | null;
}
